class FeatureTabs {
	constructor( el ) {
		this.el = el;
		this.tabs = Array.from( el.querySelectorAll( '.feature-tabs__tab-label[role="tab"]' ) );
		this.panels = Array.from( el.querySelectorAll( '.feature-tabs__tab-content[role="tabpanel"]' ) );
		this.accordionBtns = Array.from( el.querySelectorAll( '.feature-tabs__tab-label-accordion' ) );

		if ( ! this.tabs.length || ! this.panels.length ) {
			return;
		}

		this.tabs.forEach( ( tab ) => tab.addEventListener( 'click', () => this.activateByTab( tab ) ) );

		el.querySelectorAll( '.feature-tabs__video-play-btn' ).forEach( ( btn ) =>
			btn.addEventListener( 'click', () => this.activateVideo( btn ) )
		);

		this.tabs.forEach( ( tab, i ) =>
			tab.addEventListener( 'keydown', ( e ) => {
				const total = this.tabs.length;
				if ( e.key === 'ArrowRight' || e.key === 'ArrowDown' ) {
					e.preventDefault();
					const next = this.tabs[ ( i + 1 ) % total ];
					this.activateByTab( next );
					next.focus();
				} else if ( e.key === 'ArrowLeft' || e.key === 'ArrowUp' ) {
					e.preventDefault();
					const prev = this.tabs[ ( i - 1 + total ) % total ];
					this.activateByTab( prev );
					prev.focus();
				} else if ( e.key === 'Home' ) {
					e.preventDefault();
					this.activateByTab( this.tabs[ 0 ] );
					this.tabs[ 0 ].focus();
				} else if ( e.key === 'End' ) {
					e.preventDefault();
					const last = this.tabs[ total - 1 ];
					this.activateByTab( last );
					last.focus();
				}
			} )
		);

		// Mobile accordion — click inside panel toggles that panel.
		this.accordionBtns.forEach( ( btn ) =>
			btn.addEventListener( 'click', () => {
				const panel = btn.closest( '.feature-tabs__tab-content' );
				const isActive = panel.classList.contains( 'feature-tabs__tab-content--active' );
				if ( isActive ) {
					// Collapse on mobile — deactivate this panel.
					panel.classList.remove( 'feature-tabs__tab-content--active' );
					btn.setAttribute( 'aria-expanded', 'false' );
					const idx = parseInt( panel.dataset.ftIndex, 10 );
					if ( this.tabs[ idx ] ) {
						this.tabs[ idx ].setAttribute( 'aria-selected', 'false' );
						this.tabs[ idx ].setAttribute( 'tabindex', '-1' );
					}
				} else {
					// Expand — activate this panel.
					const idx = parseInt( panel.dataset.ftIndex, 10 );
					if ( ! isNaN( idx ) && this.tabs[ idx ] ) {
						this.activateByTab( this.tabs[ idx ] );
					}
				}
			} )
		);
	}

	activateByTab( tab ) {
		const targetIndex = parseInt( tab.dataset.ftIndex, 10 );

		this.tabs.forEach( ( t, i ) => {
			const isActive = i === targetIndex;
			t.setAttribute( 'aria-selected', isActive ? 'true' : 'false' );
			t.setAttribute( 'tabindex', isActive ? '0' : '-1' );
		} );

		this.panels.forEach( ( panel, i ) => {
			const isActive = i === targetIndex;
			panel.classList.toggle( 'feature-tabs__tab-content--active', isActive );

			const accordionBtn = panel.querySelector( '.feature-tabs__tab-label-accordion' );
			if ( accordionBtn ) {
				accordionBtn.setAttribute( 'aria-expanded', isActive ? 'true' : 'false' );
			}

			// Pause any playing video when its panel becomes inactive.
			if ( ! isActive ) {
				panel.querySelectorAll( 'video' ).forEach( ( v ) => {
					if ( ! v.paused ) {
						v.pause();
					}
				} );
			}
		} );
	}

	activateVideo( btn ) {
		const wrapper = btn.closest( '.feature-tabs__video' );
		if ( ! wrapper ) {
			return;
		}
		wrapper.classList.add( 'feature-tabs__video--playing' );
		const video = wrapper.querySelector( 'video' );
		if ( video ) {
			video.removeAttribute( 'hidden' );
			video.play().catch( () => {} );
		}
	}
}

document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.feature-tabs' ).forEach( ( el ) => new FeatureTabs( el ) );
} );
